import {
  countMetricOptions,
  GoalMetric,
  MetricEntry,
  MetricTemplate,
  MetricUnit,
  MetricUnitIds,
} from '@griply/types';

import { isNumber } from './is-number';
import { parseNumericInput } from './parse-numeric-input';

export type BuildGoalMetricOptions = {
  template: MetricTemplate;
  startValue: string;
  targetValue: string;
  unitValue: string;
  entries: MetricEntry[] | null;
};

export const buildGoalMetric = ({
  template,
  startValue,
  targetValue,
  unitValue,
  entries,
}: BuildGoalMetricOptions): GoalMetric => {
  const isCount = countMetricOptions.includes(template.id);

  const templateUnit = unitValue
    ? template.unitOptions?.find(
        ({ id, name }) =>
          id === unitValue || Object.values(name).includes(unitValue),
      )
    : undefined;

  const unit: MetricUnit = {
    id: templateUnit?.id ?? MetricUnitIds.Custom,
    name: templateUnit?.name ?? unitValue,
    symbol: templateUnit?.symbol ?? null,
    format: templateUnit?.format ?? null,
  };

  const parseValue = (value: string): number | null => {
    if (isCount || !value.trim()) {
      return null;
    }
    const parsed = parseNumericInput(value);
    return isNumber(parsed) ? parsed : null;
  };

  return {
    id: template.id,
    startValue: parseValue(startValue),
    targetValue: parseValue(targetValue),
    unit,
    entries,
  };
};
